import React from 'react'
import { useViewport } from '../../../utils'

const ProfileHeaderImage = ({image = '/images/khub_mahmud.jpg'}) => {
  const { isMobile } = useViewport()
  const size = isMobile ? '73px' : '140px'

  return (
    <div
      style={{width: size, height: size, backgroundImage: `url(${image})`}}
      className={`rounded-full bg-no-repeat bg-cover bg-center shadow`}
    />
  )
}

export { ProfileHeaderImage }
